import React from "react"
import {
    Button,
    Grid,
    IconButton,
    Stack,
    Typography,
    Avatar,
    Card,
    CardHeader,
    CardContent,
    Tooltip
} from '@mui/material';
import useApiCall, {makeApiCall} from "../../hooks/CancellableApiCall";
import {CareersResponse} from "../../data/CareersResponse";
import useUser from "../../hooks/useUser";
import {LoadingContent} from "../../components/LoadingContent";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {ApplicationRequirement} from "./CareersPage";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';

const ClosedApplication = (props: { application: CareersResponse }) => {
    let lastAssessmentButton = <></>
    const navigate = useNavigate()

    if (props.application.lastAssessmentId != null) {
        lastAssessmentButton = <Button component={RouterLink}
                to={`/assessments/user/${props.application.lastAssessmentId}/review`} size={"small"} color="info"
                variant="text">Review last Stage</Button>
    }

    let applicationTitle
    if (props.application.type === "rank") {
        applicationTitle = props.application.rankOnPassDisplayName
    } else if (props.application.type === "division_role") {
        applicationTitle = props.application.roleName
    } else if (props.application.type === "taser") {
        applicationTitle = "Taser"
    } else if (props.application.type === "certification") {
        applicationTitle = props.application.certificationName
    } else {
        applicationTitle = "UNKNOWN APPLICATION TYPE"
    }

    let viewApplicantsButton = <></>
    if (props.application.state === "closed") {
        viewApplicantsButton = <Button component={RouterLink}
                to={`/careers/overview/${props.application.id}/passed`} size={"small"} color="primary"
                variant="contained">View Applicants</Button>
    }

    let copyApplicationButton = <></>
    if (props.application.state === "closed") {
        copyApplicationButton = <Tooltip title="Copy Application">
           <IconButton sx={{float: "right"}} size="small" color="info" onClick={() => {
                  makeApiCall({
                      url: `/api/careers/${props.application.id}/copy`,
                      method: "GET",
                      onLoadedCallback: (data: {newApplicationId: number}) => {
                          navigate(`/edit-application/${data.newApplicationId}`)
                      },
                      onError: () => {}
                  })
              }}> <ContentCopyOutlinedIcon/> </IconButton>
           </Tooltip>
    }

    let reopenApplicationButton = <></>
    if (props.application.state === "closed") {
        reopenApplicationButton = <Tooltip title="Reopen Application">
           <IconButton sx={{float: "right"}} size="small" color="success" onClick={() => {
                  makeApiCall({
                      url: `/api/careers/${props.application.id}/state`,
                      method: "PATCH",
                      body: {
                          state: "locked"
                      },
                    onLoadedCallback: () => {
                        navigate(`/careers/overview/${props.application.id}/passed`)
                    },
                      onError: () => {}
                  })
              }}> <LockOpenOutlinedIcon/> </IconButton>
           </Tooltip>
    }

    return (
        <Card sx={{ maxWidth: 500 }}>
        <Stack sx={{float: "right", mt: 0.5, mr: 1, overflow: "hidden"}} direction={"row"}>
            {copyApplicationButton}
            {reopenApplicationButton}
        </Stack>
            <CardHeader
                title = {applicationTitle}
                subheader = {props.application.divisionName}
                avatar = {<Avatar
                    src={props.application.divisionBadge}
                    sx={{ width: 85, height: 85}}
                    variant="square"
                />}/>
            <CardContent>
                <Typography variant="body2" style={{whiteSpace: 'pre-line'}}>
                    {props.application.description}
                </Typography>
                <hr/>
                {
                    props.application.requirements?.map(requirement => {
                        return <ApplicationRequirement type={requirement.type} param={requirement.param} met={requirement.met} key={requirement.id}/>
                    })
                }
                <Stack spacing={2} sx={{mt: 1}}>
                    {viewApplicantsButton}
                    {lastAssessmentButton}
                </Stack>
            </CardContent>
        </Card>
    )
}

export const ClosedCareersPage = () => {
    const applications = useApiCall<Array<CareersResponse>>({
        url: `/api/careers/closed`,
    })

    const userData = useUser()

    const user = userData.user

    return (
        <LoadingContent isLoading={
            userData.isLoading || !user ||
            applications.isLoading ||  !applications
        }>
            <Stack spacing={2}>
                <Button sx={{width: 200}} color="info" variant="contained" component={RouterLink}
                        to={`/careers`}>Open Applications</Button>
                <Grid container spacing={2}>
                    {applications.data && applications.data.map(application => {
                            return <Grid sx={{paddingTop: 5, paddingRight: 5}} xs={12} sm={12} md={12} lg={6} xl={3} key={application.id}>
                                <ClosedApplication
                                    application={application}
                                />
                            </Grid>
                        }
                    )}
                </Grid>
            </Stack>
        </LoadingContent>
    )
}